import CustomApiError from './CustomApiError'

export default class HolderError extends CustomApiError {
  toDictionary () {
    return {
      'ALREADY_APPROVED': 'Conta já aprovada.',
      'ALREADY_REPROVED': 'Conta já reprovada.',
      'ALREADY_ACTIVATED': 'Conta já ativada.',
      'ALREADY_DEACTIVATED': 'Conta já inativada.',
      'ALREADY_ON_BLACKLIST': 'Conta já está na blacklist.',
      'ALREADY_ON_WHITELIST': 'Conta já está na withelist.',
      'ALREADY_BALANCE_BLOCKED': 'Saldo já bloqueado.',
      'ALREADY_BALANCE_UNBLOCKED': 'Saldo já desbloqueado.',
      'NOT_APPROVED_YET': 'Conta não ainda não está aprovada.',
      'HOLDER_NOT_FOUND': 'Lojista não encontrado.'
    }
  }
}
